import { render, staticRenderFns } from "./contactform.vue?vue&type=template&id=7cb074ce&lang=pug&"
import script from "./contactform.vue?vue&type=script&lang=js&"
export * from "./contactform.vue?vue&type=script&lang=js&"
import style0 from "./contactform.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports